<template>
  <div class="Chart__Legend">
    <ul>
      <li
        v-for="(asset, key) in assets"
        @mouseenter="onMouseenter(asset)"
        @mouseleave="onMouseleave"
        :key="asset.id + asset.symbol + asset.exchId"
      >
        <span
          class="Chart__Legend--color"
          :style="'background-color:' + colors[key]"
        >
          <input
            type="color"
            name="color"
            class="Chart__Legend--color-input"
            :value="colors[key]"
            @change="onColorChange($event, asset)"
          />
        </span>
        <span
          class="Chart__Legend--label-text"
          :title="asset.exchId > 0 ? exchIdToName(asset.exchId) : ''"
        >
          {{ asset.name }}
        </span>
        <ExchangeIcon
          v-if="asset.exchId > 0"
          :exchId="asset.exchId"
          :size="14"
          class="Chart__Legend--exchnageIcon"
        />
      </li>
    </ul>
    <p class="small text-center text-muted m-0">
      {{ $t("charts.color_help") }}
      <i class="fa fa-paint-brush m-2"></i>
    </p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Options from "@/options";
import ExchangeIcon from "@/components/ExchangeIcon";

export default {
  name: "Legend",
  components: {
    ExchangeIcon,
  },
  computed: {
    colors() {
      return Options.chartColors.map((color, key) => {
        return this.assets[key] &&
          this.assets[key].color &&
          /^\#[A-F0-9]+$/i.test(this.assets[key].color)
          ? this.assets[key].color
          : color;
      });
    },
    assets() {
      return this.profitlossMode
        ? this.portfolioAssetsSortedByShare_pl
        : this.portfolioAssetsSortedByShare;
    },
    ...mapGetters({
      profitlossMode: "settings/profitlossMode",
      portfolioAssetsSortedByShare: "portfolio/portfolioAssetsSortedByShare",
      portfolioAssetsSortedByShare_pl:
        "profitloss/portfolioAssetsSortedByShare",
    }),
  },
  methods: {
    exchIdToName(exchId) {
      return Options.exchIdToObj(exchId).name;
    },
    onColorChange(e, asset) {
      const assetData = { exchId: asset.exchId, currencyId: asset.currencyId, color: e.target.value };
      if (this.profitlossMode && !asset.colorIsFromPortfolio) {
        this.updateAsset_pl(assetData);
      } else {
        this.updateAsset(assetData);
      }
    },
    onMouseenter(asset) {
      this.$emit('tooltip', asset);
    },
    onMouseleave() {
      this.$emit('tooltip', {});
    },
    ...mapActions({
      updateAsset: "portfolio/updateAsset",
      updateAsset_pl: "profitloss/updateAsset",
    }),
  },
};
</script>

<style lang="scss">
.Chart__Legend {
  ul {
    padding: 0;
    list-style: none;
    text-align: center;
    margin: 25px 0 0;
    line-height: 2;
  }
  li {
    display: inline-block;
    margin-right: 10px;
  }
  &--color {
    position: relative;
    display: inline-block;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    margin: 0 5px -1px 3px;
    overflow: hidden;
  }
  &--color-input {
    position: absolute;
    cursor: pointer;
    left: -50%;
    top: -50%;
    height: 200%;
    width: 200%;
    border: 0;
    padding: 0;
    margin: 0;
    -webkit-appearance: none;
  }
  &--exchnageIcon {
    position: relative;
    top: -7px;
  }
}
</style>